export class TenderTabCountDto {
    noteCount: number;
    reminderCount: number;
    public constructor(init?: Partial<TenderTabCountDto>) {
        Object.assign(this, init);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/tenders/tender.tab.count.model.ts